import { Component, Input } from '@angular/core';
import type { IBiLink } from '../../../../shared/interfaces/bi-link.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-toggle-group-navigation',
  templateUrl: './toggle-group-navigation.component.html',
  styleUrls: ['./toggle-group-navigation.component.scss'],
})
export class ToggleGroupNavigationComponent {
  @Input() links: IBiLink[] = [];
  @Input() showIcons = false;
}
